import React, { FC } from 'react';

import styled from 'styled-components';

interface StyleProps {
    bgColor: string;
}

interface AampeIconBackgroundProps {
    primaryColor: string;
    secondaryColor: string;
}

const AampeIconBackground: FC<
    React.PropsWithChildren<AampeIconBackgroundProps>
> = ({ primaryColor, secondaryColor, children }) => {
    return (
        <PrimaryCircle bgColor={primaryColor}>
            <SecondaryCircle bgColor={secondaryColor}>
                {children}
            </SecondaryCircle>
        </PrimaryCircle>
    );
};

const PrimaryCircle = styled.div<StyleProps>((props) => ({
    backgroundColor: props.bgColor,
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}));

const SecondaryCircle = styled.div<StyleProps>((props) => ({
    backgroundColor: props.bgColor,
    width: '35px',
    height: '35px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}));

export default AampeIconBackground;
